module.exports = __webpack_public_path__ + "img/nongye_4.09dd890d.png";